import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MessageTranslateService } from "../../../../shared/services/message.service";
import * as chargerStatisticsActions from './charger.statistics.actions';
import { catchError, map, of, switchMap } from "rxjs";
import { ChargerService } from "../../services/charger.service";
import { ErrorUtil } from "../../../../shared/utils/error.util";

export class ChargerStatisticsEffects {
    actions$: Actions = inject(Actions);
    messageService = inject(MessageTranslateService);
    chargerService = inject(ChargerService);

    loadChargerStatistics$ = createEffect(() =>
        this.actions$.pipe(
            ofType(chargerStatisticsActions.loadChargerStatistics),
            switchMap(requestData => {
                return this.chargerService.loadChargerStatistics(requestData.chargerId, requestData.dateFrom, requestData.dateTo, requestData.connectorId)
                    .pipe(
                        map(res =>
                            chargerStatisticsActions.loadChargerStatisticsSuccess({ chargerStatistics: res })
                        ),
                        catchError(err =>
                            of(chargerStatisticsActions.loadChargerStatisticsFailure({ error: ErrorUtil.convertToErrorModel(err) }))
                        )
                    )
            })
        )
    )
}